import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Input , InputLabel} from '@material-ui/core'; 
import InputAdornment from '@material-ui/core/InputAdornment';
import PermContactCalendar from '@material-ui/icons/PermContactCalendar';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './kicker-jss'; 
import ls from 'local-storage';
import ColorPicker from '../../../../atoms/ColorPicker';
import { primary, secondary } from '../../../../utils/colors';

class AddKickerForm extends React.Component {
 
  state ={
    kicker_name:'',
    synthesis:0,
    kicker_color:'',
    openNotification:false,
    typeNotification:"info",
    messageNotification:"",
    kicker_color: ""
  }

  resetValues = (band) =>{
    if(band){
      this.setState({
        kicker_name:'',
        synthesis:0,
        kicker_color:''
      })
    }else{
      this.setState({
        kicker_name : this.props.dataInit ? this.props.dataInit.kicker_name :'',
        synthesis : this.props.dataInit ? this.props.dataInit.menu_id : 0,
        kicker_color:this.props.dataInit? this.props.dataInit.kicker_color : ''
      })
    }
  }
  
  handleChange = event => {
    if(event.target.name==="kicker_name" && event.target.value.length<26)
      this.setState({ [event.target.name]: event.target.value });
  };
  handleChangeSelect = event => {
      this.setState({ [event.target.name]: event.target.value });
  };

  handleChangeComplete = (color) => {
    if(color){
      this.setState(
        {
          kicker_color : color.hex
        }
      )
    }
  };

  onChange = (color) => {
    if(color){
      this.setState(
        {
          kicker_color : color.hex
        }
      )
    }
  }

  componentWillReceiveProps(newProps){
    
    if(!newProps.isOpen){
      this.resetValues(true);
    }
    if(newProps.dataInit != null){
      this.setState({
        kicker_name : newProps.dataInit ? newProps.dataInit.kicker_name :'',
        synthesis : newProps.dataInit ? parseInt(newProps.dataInit.menu_id) : 0,
        kicker_color : newProps.dataInit? newProps.dataInit.kicker_color:''
    });
    }
    
  }

  render() {
    const {
      classes,
      pristine,
      submitting,
      handleSubmit
    } = this.props;
 
      return(
        <div>
         
        <form onSubmit={(event) => handleSubmit(event, this.state)}>
          <section className={classes.bodyForm}>     
            <div>
              <InputLabel htmlFor="kicker_name">Nombre</InputLabel>
              <Input 
                id="kicker_name"
                name="kicker_name"
                value={this.state.kicker_name}
                type="text"
                autoComplete="off"
                required
                className={classes.field}
                startAdornment={
                  <InputAdornment position="start">
                    <PermContactCalendar />
                  </InputAdornment>
                }
                onChange={this.handleChange}
              />
            </div>
            <div>
              <InputLabel htmlFor="synthesis">Síntesis</InputLabel>
              <Select
                value={this.state.synthesis}
                onChange={this.handleChangeSelect}
                className={classes.field}
                name="synthesis"
              >
                {
                  ls.get("session_menu").map((item, index) =>{
                    return(
                      <MenuItem key={index.toString()} value={item.menu_id}>{item.menu_name}</MenuItem>
                    );
                  })                                
                }
              </Select>
            </div>
            <div>
              <InputLabel htmlFor="kicker_color" className={classes.dblock}>Selecciona un color</InputLabel>
              <div className={classes.colorsPicker}>
                <ColorPicker 
                    color={this.state.kicker_color}
                    colors={[...primary, ...secondary]}
                    triangle={`top`}
                    width={`100%`}
                    onChange={this.onChange}
                    onChangeComplete={this.handleChangeComplete}
                />
              </div>
            </div>
          </section>
          <div className={classes.buttonArea}>
            <Button variant="raised" color="primary" type="submit" disabled={this.state.kicker_color!=='' && this.state.synthesis!==0?false:true}>
              Guardar
            </Button>
            <Button
              type="button"
              disabled={pristine || submitting}
              onClick={() =>{this.resetValues(false)}}
            >
              Deshacer
            </Button>
          </div>
        </form>
      </div>
      )
     
  }
}

AddKickerForm.propTypes = {
  classes: PropTypes.object,
  handleSubmit: PropTypes.func,
  reset: PropTypes.func,
  onDrop: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
  imgAvatar: PropTypes.string,
  dataInit:PropTypes.object,
  isOpen:PropTypes.bool
};
 

export default withStyles(styles)(AddKickerForm);
